<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    header="Select Prospect List" styleClass="p-dialog-width-50" (onHide)="onCancel()">

    <div class="dialog-content">
        <div class="select-container">
            <label for="prospectSelect">Select Prospect List:</label>
            <p-select [options]="filteredLists" [(ngModel)]="selectedList" optionLabel="name"
                placeholder="Choose a prospect list..." [style]="{'width':'100%'}" [filter]="true"
                filterBy="name,description" [showClear]="true" inputId="prospectSelect">

                <ng-template let-list pTemplate="item">
                    <div class="select-item">
                        <div class="list-name">{{ list.name }}</div>
                        <div class="list-description" *ngIf="list.description">
                            {{ list.description }}
                        </div>
                        <div class="list-count" *ngIf="list.count !== undefined">
                            {{ list.count }} prospects
                        </div>
                    </div>
                </ng-template>

                <ng-template let-list pTemplate="selectedItem">
                    <div class="selected-item" *ngIf="list">
                        <div class="selected-name">{{ list.name }}</div>
                        <div class="selected-count" *ngIf="list.count !== undefined">
                            ({{ list.count }} prospects)
                        </div>
                    </div>
                </ng-template>
            </p-select>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="onCancel()" class="p-button-text">
            </p-button>
            <p-button label="Select" icon="pi pi-check" (onClick)="onSelect()" [disabled]="!selectedList">
            </p-button>
        </div>
    </ng-template>
</p-dialog>